.controlsRow {
  align-items: center;
  container-name: PlayerButtonHBox;
}

.iconButton {
  padding: 0;
}

.progress {
  margin-left: 16px;
}
